'use client';

import { useNowStatus } from '../../hooks/useNowStatus';
import { colorOf, labelOf } from '../../lib/focusModes';
import styles from './NowStatus.module.css';

export const NowStatus = () => {
  const { focus, city, heartRate } = useNowStatus();

  return (
    <div className={styles.now}>
      <span className={styles.eyebrow}>Right now</span>

      <div className={styles.line}>
        <span className={styles.pill}>
          <span
            className={styles.dot}
            style={{ background: focus ? colorOf(focus) : '#666' }}
          />
          {focus ? labelOf(focus) : 'Off the clock'}
        </span>

        {city && <span className={styles.meta}>in {city}</span>}

        {heartRate != null && (
          <span className={styles.meta}>{Math.round(heartRate)} bpm</span>
        )}
      </div>
    </div>
  );
};
